/**
 * Extract a user-friendly error message from an API error response.
 * Handles: string body, {error: "..."}, {detail: "..."}, {field: ["msg"]}.
 */
export function getApiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data.error) return data.error;
  if (data.detail) return data.detail;
  const first = Object.values(data)[0];
  if (Array.isArray(first)) return first[0] || fallback;
  if (typeof first === "string") return first;
  return fallback;
}
